import React from 'react';
import useExcelStyles from '../useExcelStyles';
import useNoRowsTemplate from '../useNoRowsOverlay';
import useLoadingOverlay from '../useLoadingOverlay';
import dateCellCallback from '../../../utils/ag-grid/processCellCallback/dateCellCallback';
import responseStatusCellCallback from '../../../utils/ag-grid/processCellCallback/responseStatusCellCallback';
import userStatusCellCallback from '../../../utils/ag-grid/processCellCallback/userStatusCellCallback';
import { TOOLTIP_SHOW_DELAY } from '../../../constants';
import type { InventoryStatus } from '../../../types/inventoryStatus';
import type { ProcessCellCallbackParams } from '../../../types/common';
import type { ColDef, ExcelStyle, GetContextMenuItemsParams, GridOptions, MenuItemDef } from 'ag-grid-community';

const useGridOptionsInventoryStatus = () => {
  const { commonExcelStyles } = useExcelStyles();

  // Excelのスタイル設定
  // ----------------------------------------
  const excelStyles: ExcelStyle[] = [...commonExcelStyles];

  // Overlayの設定
  // ----------------------------------------
  const overlayLoadingTemplate: string = useLoadingOverlay();
  const overlayNoRowsTemplate: string = useNoRowsTemplate();

  // rowNodeIdの設定
  // ----------------------------------------
  const getRowNodeId = (params: InventoryStatus) => String(params.id);

  // 右クリックメニューの設定
  // ----------------------------------------
  const getContextMenuItems = (params: GetContextMenuItemsParams): (string | MenuItemDef)[] => {
    // console.log(params);
    if (params.node) {
      // Excel用の変換を行う
      const processCellCallback = (params: ProcessCellCallbackParams): string => {
        // console.log(params.value);
        const myColDef: ColDef = params.column.getColDef();
        const myField: string | undefined = myColDef.field ?? myColDef.colId;
        if (myField === 'firstMailDate' || myField === 'secondMailDate' || myField === 'responseDate' || myField === 'lastDeleteDate') {
          const formattedValue: string = dateCellCallback(params);
          // console.log(formattedValue);
          return formattedValue;
        } else if (myField === 'responseStatus') {
          const formattedValue: string = responseStatusCellCallback(params);
          // console.log(formattedValue);
          return formattedValue;
        } else if (myField === 'userStatus') {
          const formattedValue: string = userStatusCellCallback(params);
          // console.log(formattedValue);
          return formattedValue;
        } else {
          return params.value ?? '';
        }
      };
      // カスタムメニューの作成
      const exportMenu = {
        icon: '<span class="ag-icon ag-icon-save" unselectable="on"></span>',
        name: 'Export',
        subMenu: [
          {
            name: 'CSV Export',
            action: () => params.api.exportDataAsCsv({ processCellCallback }),
          },
          {
            name: 'Excel Export (.xlsx)',
            action: () => params.api.exportDataAsExcel({ processCellCallback }),
          },
          // {
          //   name: 'Excel Export (.xml)',
          //   action: () => params.api.exportDataAsExcel({ exportMode: 'xml' }),
          // },
        ],
      };
      // 右クリックメニューの項目
      const menuItems = ['copy', 'copyWithHeaders', 'separator', exportMenu];
      return menuItems;
    } else {
      // データrowでないエリアを右クリックしたときはメニューは表示しない
      return [];
    }
  };

  // GridOptions全体
  // ----------------------------------------
  const gridOptions: GridOptions = {
    columnTypes: {
      nonEditableColumn: {
        editable: false,
      },
    },
    editType: 'fullRow',
    excelStyles,
    getContextMenuItems,
    getRowNodeId,
    overlayLoadingTemplate,
    overlayNoRowsTemplate,
    pagination: true,
    paginationPageSize: 100,
    suppressClickEdit: true,
    tooltipShowDelay: TOOLTIP_SHOW_DELAY,
  };
  return { gridOptions };
};

export default useGridOptionsInventoryStatus;
